import { render, staticRenderFns } from "./Openclass.vue?vue&type=template&id=bbb39528&scoped=true"
var script = {}
import style0 from "./Openclass.vue?vue&type=style&index=0&id=bbb39528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb39528",
  null
  
)

export default component.exports